import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogTrigger } from '../ui/alert-dialog'
import { Button } from '../ui/button'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const Actions = () => {
    const { t } = useTranslation()
    const actions:Action[] = useSelector((state:RootState)=>state.actions)

    const ViewAll = () => {
        return (
            <AlertDialog>
                <AlertDialogTrigger asChild><div className="flex justify-center"><button className="font-semibold text-sm text-cyan-700 hover:underline w-fit">{t('Alles bekijken')}</button></div></AlertDialogTrigger>
                <AlertDialogContent className='max-h-[90vh] overflow-auto'>
                    <div className='bg-white grid grid-cols-3'>
                        <i></i>
                        <div className='flex justify-center items-center'><h1 className='text-lg font-semibold'>{t('Acties')}</h1></div>
                        <div className='flex justify-end'><AlertDialogCancel asChild><Button variant='ghost' className='w-fit'><X /></Button></AlertDialogCancel></div>
                        
                    </div>
                    
                    <div className='grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-4'>
                        {actions.map((action, index) => {
                            return (
                                <div className='bg-white rounded-sm border flex flex-col p-3 hover:shadow-sm hover:scale-[1.02] duration-200' key={index}>
                                    <p className='flex items-center gap-1 text-sm text-neutral-400'>{t('Deadline')}: {action.deadlinedate}</p>
                                    <p className='font-medium'>{action.title}</p>
                                    <p className='text-sm text-neutral-700'>{action.description}</p>
                                </div>
                            )
                        })}
                    </div>
                </AlertDialogContent>
            </AlertDialog>
        )
    }

    return (
    <div className='flex flex-col'>
        <h2 className='font-semibold text-neutral-600 mb-2'>{t('Openstaande acties')}</h2>

        <div className='flex flex-col gap-4'>
            {actions.slice(0,3).map((action, index) => {
                return (
                    <div className='bg-white rounded-sm border flex gap-2 p-3 hover:shadow-sm hover:scale-[1.02] duration-200' key={index}>
                        <div className='flex items-center'>
                            <div className='border rounded-sm w-12 h-12 flex justify-center items-center'>
                                <svg className='w-7 opacity-50' xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48"><path d="M292 550q18-36 38.5-71t43.5-67l-79-16-109 109 106 45Zm515-312q-102 5-184 43.5T463 398q-31 31-64 81t-59 107l133 133q57-26 107-59t81-64q78-78 116.5-159.5T821 253q0-3-1-6t-3-5q-2-2-4.5-3t-5.5-1ZM570 490q-20-20-20-49.5t20-49.5q20-20 49.5-20t49.5 20q20 20 20 49.5T669 490q-20 20-49.5 20T570 490Zm-61 278 45 105 109-109-15-79q-32 23-67.5 44T509 768Zm373-559q3 125-40.5 230.5T704 639q-1 1-2 1.5t-2 1.5l22 110q3 15-1 29t-15 25L565 947q-11 11-26.5 8T517 937l-68-157-169-170-158-67q-15-6-17.5-22t8.5-27l140-140q11-11 25-15.5t29-1.5l110 22q1-1 2-1.5t2-1.5q94-94 199-137.5T850 178q6 0 11.5 2.5T872 188q5 5 7.5 10t2.5 11ZM149 731q35-35 85.5-35.5T320 730q35 35 34.5 85.5T319 901q-26 26-80.5 43T75 976q15-109 31.5-164t42.5-81Zm42 43q-14 15-25 47t-19 82q50-8 82-19t47-25q19-17 19.5-42.5T278 772q-19-18-44.5-17.5T191 774Z"/></svg>
                            </div>
                        </div>
                        <div className='w-full'>
                            <p className='flex items-center gap-1 text-sm text-neutral-400'>
                                <span><svg className='w-4' viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></span>
                                {t('Deadline')}: {action.deadlinedate}
                            </p>
                            <p className='font-medium'>{action.title}</p>
                            {action.description !== '' && <p className='text-sm text-neutral-700'>{action.description}</p>}
                        </div>
                    </div>
                )
            })}
            {actions.length > 2 &&
                <ViewAll />
            }
        </div>
    </div>
  )
}

export default Actions